import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import renderHTML from "react-render-html";
import { getBenificiary } from "../../store/actions/benificiarys_action";
import Spinner from "../../components/layout/Spinner";
import SingleItem from "../../components/template/SingleItem";
import { Link } from "react-router-dom";
const ViewBenificiary = ({
  getBenificiary,
  match,
  benificiary: { loading, benificiary },
}) => {
  useEffect(() => {
    getBenificiary(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Benificiarys"
          mainLinkTitle="Benificiarys"
          mainLinkUrl="/benificiarys"
          activeLink="View"
        />
        {!loading ? (
          benificiary && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-4">
                  <div className="card">
                    <div className="card-header">
                      <div>
                        <h4 className="card-title">
                          {benificiary.name} <span>View</span>
                        </h4>
                        <p className="card-title-desc">
                          <Link
                            to="/benificiarys"
                            className="btn btn-soft-light"
                          >
                            <i className="fa fa-angle-left"></i> Benificiarys
                          </Link>
                          <Link
                            to={`/benificiarys/${benificiary.id}/edit`}
                            className="btn btn-soft-light"
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </p>
                      </div>
                    </div>
                    <div className="card-body">
                      <SingleItem title="title" value={benificiary.title} />

                      {benificiary.featured_image && (
                        <SingleItem title="Featured Image">
                          <img
                            src={`${benificiary.featured_image}`}
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "contain",
                            }}
                          />
                        </SingleItem>
                      )}
                      {benificiary.gallery && (
                        <SingleItem title="Gallery">
                          {benificiary.gallery.map((pic) => {
                            return (
                              <img
                                src={pic}
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  objectFit: "contain",
                                }}
                              />
                            );
                          })}
                        </SingleItem>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="card">
                    <div className="card-header"> Content </div>
                    <div className="card-body">
                      <div className="card-content">
                        {benificiary.content && renderHTML(benificiary.content)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ benificiary: state.benificiary });

const mapDispatchToProps = { getBenificiary };

export default connect(mapStateToProps, mapDispatchToProps)(ViewBenificiary);
